import { useMemo } from 'react';
import { useAuthentication, useChannels } from '@connect-x-app/hybrid-state';
import { FlightRoomUserStatus } from '@connect-x-app/shared-domain-models';
import { COLORS } from '@connect-x-app/shared-ui';
import { CHANNEL_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Icon, ModalOpener } from '@connect-x-app/web-ui';

import { UserRequestAccessModal } from '../../userRequestAccessModal/UserRequestAccessModal';

export const GrantAccess = () => {
  const { hasGrantAccess } = useAuthentication();
  const { roomChannels } = useChannels();

  const pendingRequests = useMemo(() => {
    return roomChannels?.mainChannel.users?.filter(({ status }) => status === FlightRoomUserStatus.PENDING) ?? [];
  }, [roomChannels?.mainChannel.users]);

  if (!hasGrantAccess || pendingRequests.length === 0) {
    return null;
  }

  const onClickRequestIcon = () => {
    ModalOpener.instance.open({
      render: () => <UserRequestAccessModal />,
    });
  };

  return (
    <Icon
      badgeText={pendingRequests.length}
      colorName={COLORS.zulu.$10}
      disabled={pendingRequests.length === 0}
      name="peopleUserManagementUserCircularPlus"
      onClick={onClickRequestIcon}
      showBadge={pendingRequests.length > 0}
      size={2.4}
      testId={CHANNEL_TEST_IDS.header.grantAccess}
    />
  );
};
